import { FC, PropsWithChildren } from 'react'
import { Outlet, RouteObject } from 'react-router-dom'
import { Layout } from '../features/layout'
import { ReactGAProvider } from '../features/react-ga-provider'

const BaseLayout: FC<PropsWithChildren> = ({ children }) => (
  <ReactGAProvider>
    <Layout>{children}</Layout>
  </ReactGAProvider>
)

export const LayoutRoute: RouteObject = {
  element: (
    <BaseLayout>
      <Outlet />
    </BaseLayout>
  )
}
